module.exports = __webpack_public_path__ + "static/img/台大實驗林.9fbf0d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/建置實績/台大實驗林.png?20181011
// module id = szvl
// module chunks = 1